import React from "react";
import "./Footer.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { updateMenu } from "Redux/Actions/menuActions";
import { Link } from "react-router-dom";
import unif from "assets/logo_unif.webp";
import reseau_pro_gris from "assets/LogoRP-2025-blanc.png";
import logo_ministere from "assets/logo_ministere.jpg";
import reseau_pro_bleu from "assets/LogoRP-2025-blanc.png";
import logo_PEP from "assets/logo_PEP.png";
import {
  FaRegCopyright,
  FaFacebook,
  FaYoutube,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
import { useIntersectionObserver } from "Services/intersectionObserver";

const Footer = (props) => {
  const API_LINK = process.env.REACT_APP_BASE_URL_API.split("/api")[0];

  const [intersectionRef, isVisibleIntersection] = useIntersectionObserver();

  return (
    <div className="footer" ref={intersectionRef}>
      {isVisibleIntersection &&
        (props.auth.isConnected ? (
          <div className="footer__top">
            <div className="footer__top__li">
              <img
                src={
                  API_LINK +
                  props.auth?.universityConnected?.imageTransparentAndWhiteUrl
                }
                alt={"Logo Université " + props.auth?.universityConnected?.name}
                title={
                  "Logo Université " + props.auth?.universityConnected?.name
                }
                loading="lazy"
              />
              <div className="footer__top__li__socialsLinks">
                <a
                  href={
                    // On vérifie si le lien commence par http
                    props.auth?.universityConnected?.facebookLink?.startsWith(
                      "http"
                    )
                      ? props.auth?.universityConnected?.facebookLink
                      : "http://" +
                        props.auth?.universityConnected?.facebookLink
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook />
                </a>
                <a
                  href={
                    // On vérifie si le lien commence par http
                    props.auth?.universityConnected?.youtubeLink?.startsWith(
                      "http"
                    )
                      ? props.auth?.universityConnected?.youtubeLink
                      : "http://" + props.auth?.universityConnected?.youtubeLink
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaYoutube />
                </a>
                <a
                  href={
                    // On vérifie si le lien commence par http
                    props.auth?.universityConnected?.twitterLink?.startsWith(
                      "http"
                    )
                      ? props.auth?.universityConnected?.twitterLink
                      : "http://" + props.auth?.universityConnected?.twitterLink
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTwitter />
                </a>
                <a
                  href={
                    // On vérifie si le lien commence par http
                    props.auth?.universityConnected?.instagramLink?.startsWith(
                      "http"
                    )
                      ? props.auth?.universityConnected?.instagramLink
                      : "http://" +
                        props.auth?.universityConnected?.instagramLink
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </a>
                <a
                  href={
                    // On vérifie si le lien commence par http
                    props.auth?.universityConnected?.linkedinLink?.startsWith(
                      "http"
                    )
                      ? props.auth?.universityConnected?.linkedinLink
                      : "http://" +
                        props.auth?.universityConnected?.linkedinLink
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin />
                </a>
              </div>
            </div>
            <div className="footer__top__text">
              <div className="footer__column">
                <div className="footer__top__li">
                  <h6 className="h1_trait_dessous">
                    <Link to={{ pathname: "/profil" }}>MON PROFIL</Link>
                  </h6>
                  <br />
                  <ul>
                    <li
                      onClick={() =>
                        props.handleMenu({
                          activeItemProfilEdit:
                            props.items.itemsProfilEdit.findIndex(
                              (v) => v.label == "Informations personnelles"
                            ),
                        })
                      }
                    >
                      <Link to={{ pathname: "/profil-edit" }}>
                        Modifier mon profil
                      </Link>
                    </li>
                    <li>
                      <Link to={{ pathname: "/profil-edit" }}>Mes CV</Link>
                    </li>
                    <li>
                      <Link to={{ pathname: "/profil" }}>Mes alertes</Link>
                    </li>
                    <li
                      onClick={() =>
                        props.handleMenu({
                          activeItemProfilEdit:
                            props.items.itemsProfilEdit.findIndex(
                              (v) => v.label == "Paramètres de confidentialité"
                            ),
                        })
                      }
                    >
                      <Link to={{ pathname: "/profil-edit" }}>
                        Paramètres de confidentialité
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="footer__top__li">
                  <h6 className="h1_trait_dessous">
                    <Link to={{ pathname: "/groupes" }}>GROUPES</Link>
                  </h6>
                  <br />
                  <ul>
                    <li
                      onClick={() =>
                        props.handleMenu({
                          activeItemGroupes: props.items.itemsGroupes.findIndex(
                            (v) => v.label == "Mes groupes d'échanges"
                          ),
                        })
                      }
                    >
                      <Link to={{ pathname: "/groupes" }}>
                        Mes groupes d&apos;échanges
                      </Link>
                    </li>
                    <li
                      onClick={() => {
                        props.handleMenu({
                          activeItemGroupes: props.items.itemsGroupes.findIndex(
                            (v) => v.label == "Événements de groupe"
                          ),
                          activeItemGroupesAdmin:
                            props.items.itemsGroupesAdmin.findIndex(
                              (v) => v.label == "Événements de groupe"
                            ),
                        });
                      }}
                    >
                      <Link to={{ pathname: "/groupes" }}>
                        Événements de groupe
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="footer__column">
                <div className="footer__top__li">
                  <h6>
                    ACTUS/CONSEILS<div className="trait_dessus"></div>
                  </h6>
                  <ul>
                    <li
                      onClick={() => {
                        props.handleMenu({
                          activeItemActu: props.items.itemsActu.findIndex(
                            (v) => v.label == "Toutes les actus"
                          ),
                        }),
                          props.handleMenu({
                            activeItemActuAdmin:
                              props.items.itemsActuAdmin.findIndex(
                                (v) => v.label == "Toutes les actus/conseils"
                              ),
                          });
                      }}
                    >
                      <Link to={{ pathname: "/actualites" }}>
                        Les dernières actus
                      </Link>
                    </li>
                    <li
                      onClick={() =>
                        props.handleMenu({
                          activeItemProfil: props.items.itemsProfil.findIndex(
                            (v) => v.label == "Ressources et guides"
                          ),
                        })
                      }
                    >
                      <Link to={{ pathname: "/profil" }}>
                        Les conseils pratiques
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="footer__top__li">
                  <h6>
                    <Link to={{ pathname: "/offres" }}>
                      OFFRES D&apos;EMPLOI
                    </Link>
                    <div className="trait_dessus"></div>
                  </h6>
                  <ul>
                    <li
                      onClick={() =>
                        props.handleMenu({
                          activeItemOffre: props.items.itemsOffre.findIndex(
                            (v) => v.label == "Trouver une offre"
                          ),
                        })
                      }
                    >
                      <Link to={{ pathname: "/offres" }}>
                        Rechercher un emploi
                      </Link>
                    </li>
                    <li
                      onClick={() =>
                        props.handleMenu({
                          activeItemOffre: props.items.itemsOffre.findIndex(
                            (v) => v.label == "Déposer une offre"
                          ),
                        })
                      }
                    >
                      <Link to={{ pathname: "/offres" }}>
                        Déposer une offre d&apos;emploi
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="footer__top">
            <div className="footer__top__li">
              <img
                src={reseau_pro_gris}
                alt="Logo Réseau Pro"
                title="Logo Réseau Pro"
                loading="lazy"
              />
            </div>
            <div className="footer__top__text">
              <div className="footer__column">
                <div className="footer__top__li">
                  <h6 className="h1_trait_dessous">À PROPOS</h6>
                  <br />
                  <ul>
                    <li>
                      <a href="/#article_presentation">
                        Présentation de Réseau Pro
                      </a>
                    </li>
                    <li>
                      <a href="/#chiffresCles">Les chiffres clés</a>
                    </li>
                  </ul>
                </div>
                <div className="footer__top__li">
                  <h6 className="h1_trait_dessous">ÉVÉNEMENTS/ACTUS/OFFRES</h6>
                  <br />
                  <ul>
                    <li>
                      <a href="/#article_offres">Dernières offres</a>
                    </li>
                    <li>
                      <a href="/#article_actualites">Dernières actus</a>
                    </li>
                    <li>
                      <a href="/#article_evenements">Prochains événements</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="footer__column">
                <div className="footer__top__li">
                  <h6 className="h1_trait_dessous">
                    <Link to={{ pathname: "/universites" }}>
                      NOS UNIVERSITÉS
                    </Link>
                  </h6>
                  <br />
                  <ul>
                    <li>
                      <Link to={{ pathname: "/universites" }}>
                        Comment faire partie de Réseau Pro ?
                      </Link>
                    </li>
                    <li>
                      <Link to={{ pathname: "/universites" }}>
                        Découvrir nos universités
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="footer__top__li">
                  <h6 className="h1_trait_dessous">
                    <Link to={{ pathname: "/espace-recruteurs" }}>
                      ENTREPRISES ET RECRUTEURS
                    </Link>
                  </h6>
                  <br />
                  <ul>
                    <li>
                      <Link to={{ pathname: "/espace-recruteurs" }}>
                        Comment rejoindre Réseau Pro ?
                      </Link>
                    </li>
                    <li>
                      <Link to={{ pathname: "/espace-recruteurs" }}>
                        Les partenaires Réseau Pro
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ))}
      {isVisibleIntersection && (
        <div className="footer__bottom">
          <div className="footer__bottom__left">
            <h6>
              <Link to={{ pathname: "/contact" }}>Contactez-nous</Link>
            </h6>
            {/* <h6>
            <Link to={{ pathname: "/aide" }}>Aide</Link>
          </h6> */}
            {/* <h6>
            <Link to={{ pathname: "/accessibilite" }}>Accessibilité</Link>
          </h6> */}
            {/* <h6>
            <Link to={{ pathname: "/gestion-cookies" }}>
              Gestion des cookies
            </Link>
          </h6> */}
            <h6>
              <Link to={{ pathname: "/mentions-legales" }}>
                Mentions légales
              </Link>
            </h6>
            <h6>
              <Link to={{ pathname: "/plan-du-site" }}>Plan du site</Link>
            </h6>
          </div>
          {props.auth.isConnected && (
            <a href="/">
              <img
                src={reseau_pro_bleu}
                alt="Logo Réseau Pro"
                title="Logo Réseau Pro"
                className="footer_rp"
                loading="lazy"
              />
            </a>
          )}
          <a
            href="https://www.transformation.gouv.fr/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={logo_ministere}
              alt="Logo du ministère de la transformation et de la fonction publiques"
              title="Logo du ministère de la transformation et de la fonction publiques"
              className="footer_mini"
              loading="lazy"
            />
          </a>
          <a
            href="https://place-emploi-public.gouv.fr/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={logo_PEP}
              alt="Logo Place de l'emploi public"
              title="Logo Place de l'emploi public"
              className="footer_pep"
              loading="lazy"
            />
          </a>
          <a href="https://unif.fr/" target="_blank" rel="noreferrer">
            <img
              src={unif}
              alt="Logo Université Numérique Île-de-France"
              title="Logo Université Numérique Île-de-France"
              className="footer_unif"
              loading="lazy"
            />
          </a>
          <div className="footer__bottom__right">
            <h6>
              Copyright <FaRegCopyright /> Réseau Pro 2022-2024
            </h6>
          </div>
        </div>
      )}
    </div>
  );
};

Footer.propTypes = {
  auth: PropTypes.object,
  handleAuth: PropTypes.func,
  handleMenu: PropTypes.func,
  items: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
});

const mapDispatchToProps = (dispatch) => ({
  handleMenu: (value) => {
    dispatch(updateMenu(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
